<template>
  <SettingsMediaUploadVideo
    prop="video"
    section="images"
    :label="$t('_web_tournament_promo-video-label', 'Promo video:')"
    :tooltip="
      $$t(
        'Promo video will be shown to all users  when they open a tournament profile for a first time.',
        'promo-video-tooltip'
      )
    "
    :width="16"
    :height="9"
    :recommended-width="1920"
    :recommended-height="1080"
    :formats="acceptedVideo"
  />
</template>

<script>
import SettingsMediaUploadVideo from '@/views/tournaments/management/singleTournament/components/SettingsMediaUploadVideo';
import { translate } from '@/mixins/translate';
export default {
  name: 'TournamentPromoVideoSetting',
  components: {
    SettingsMediaUploadVideo,
  },
  mixins: [translate('_web_tournament_settings')],
  computed: {
    acceptedVideo() {
      return ['mp4', 'mov', '3gp', 'MP4', 'MOV', '3GP'];
    },
  },
};
</script>
